import config from 'devextreme/core/config';
const LICENSE_KEY = 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImVhOTEyZDM0LTM1NzktNGFlMC1hMGNlLWI4NzRlOTUxZTMwOCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjMyCn0=.A+w8Fb6MQftufb60FzYrf5nus4z6OeP9iwEBjRrJHSHMIOmLeF0feWLwA5Y5hkwiqUkVD5JOwO/FIp+UsqsI4m5nnaDU57TieZFrsHyuEYvg6U1bPMVptL/cGRMIicAB/OmiRw=='
 
config({ licenseKey:LICENSE_KEY });